// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a93db639","186":"8f18b7f6","272":"dc026a63","372":"98d0bdfd","377":"9d922d76","630":"f1a30380","841":"1e0bcb76","851":"476c0f74","856":"ab259511","858":"1eb5f413"}[chunkId] + ".chunk.js";
};